import { render, staticRenderFns } from "./SystemOverview.vue?vue&type=template&id=185497dc&scoped=true"
import script from "./SystemOverview.vue?vue&type=script&lang=js"
export * from "./SystemOverview.vue?vue&type=script&lang=js"
import style0 from "./SystemOverview.vue?vue&type=style&index=0&id=185497dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185497dc",
  null
  
)

export default component.exports